import { useMemo } from 'react';
import { TakerMarket } from '@/enterprise/data/useTakerMarkets';
import useEnablePricing from './useEnablePricing';
import { getMarketPricingTypeScenario, getNameYourRateMarketsCount } from './utils';

/**
 * checks for mixed pricing types and gets name your rate market count
 */
const useMixedPricingInfo = (takerMarkets: TakerMarket[]) => {
  const enablePricing = useEnablePricing();

  return useMemo(() => {
    const nameYourRateMarketsCount = getNameYourRateMarketsCount(takerMarkets);
    const pricingTypeScenario = getMarketPricingTypeScenario(takerMarkets);
    const displayAdditionalNameYourRateInfo = !enablePricing && pricingTypeScenario === 'mixed';

    return {
      displayAdditionalNameYourRateInfo,
      nameYourRateMarketsCount,
    };
  }, [enablePricing, takerMarkets]);
};

export default useMixedPricingInfo;
